import React from "react";
import FullPageLoaderWithPortal from "../loader";
import usePaymentService from "./service";
import { PaymentComponentProps, PaymentGatewayType } from "./types";
import StripeComponent from "./components/stripe";
import BraintreeComponent from "./components/braintree";

function PaymentComponent({
  setPaymentNonce,
  amountObj,
  registrationParticipantId,
  invoicePayerId,
  showCardIcons = true,
  purchaseOrderId,
  stripeReturnUrl,
  errorHandler,
  onAmountMismatch,
  logPurchaseError,
  onTokenInitialised,
  onPurchaseOrderVerificationFailure,
  backToOfflineRequestedClickHandler
}: PaymentComponentProps) {
  const service = usePaymentService({
    amountObj,
    setPaymentNonce,
    registrationParticipantId,
    purchaseOrderId,
    stripeReturnUrl,
    invoicePayerId,
    onTokenInitialised,
    errorHandler
  });

  return (
    <React.Fragment>
      <FullPageLoaderWithPortal isLoading={service.displayLoader} />
      <div className="paymentWrapper_body">
        {service.paymentGatewayType === PaymentGatewayType.BRAINTREE && (
          <BraintreeComponent
            showCardIcons={showCardIcons}
            service={service}
            backToOfflineRequestedClickHandler={backToOfflineRequestedClickHandler}
          />
        )}
        {service.paymentGatewayType === PaymentGatewayType.STRIPE && (
          <StripeComponent
            service={service}
            stripeReturnUrl={stripeReturnUrl}
            registrationParticipantId={registrationParticipantId}
            purchaseOrderId={purchaseOrderId}
            onAmountMismatch={onAmountMismatch}
            amountObj={amountObj}
            logPurchaseError={logPurchaseError}
            setPaymentNonce={setPaymentNonce}
            invoicePayerId={invoicePayerId}
            onPurchaseOrderVerificationFailure={onPurchaseOrderVerificationFailure}
            backToOfflineRequestedClickHandler={backToOfflineRequestedClickHandler}
          />
        )}
      </div>
    </React.Fragment>
  );
}

export default PaymentComponent;
